/*
 * ls-elements
 * Copyright (C) 2024 Libriciel SCOP
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {Injectable} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import { FieldDefinition } from 'src/app/model/field-definition';

@Injectable({
  providedIn: 'root'
})
export class QuestionControlService {

  constructor() {
  }

  toFormGroup(questions: FieldDefinition<any>[], doOnChange: (values: any, formGroup: FormGroup, questions: FieldDefinition<any>[]) => void) {
    const group: any = {};

    questions.forEach(question => {
      group[question.key] = question.required ? new FormControl({value: question.value || '', disabled: question.disabled}, question.validators.concat(Validators.required))
        : new FormControl(question.value || '', question.validators);
    });
    const formGroup = new FormGroup(group);
    formGroup.valueChanges.subscribe(value => {
      doOnChange(value, formGroup, questions);
    });
    return formGroup;
  }
}
